import { Box, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import Content2DArt from "../components/2DArtContent/Content2DArt";
import Content2DArtMobile from "../components/2DArtContent/Content2DArtMobile";
import CountUpLabel from "../components/CountUpLabel";
import { InfiniteRollingLogos } from "../components/InfiniteRollingLogos";
import MySeparator from "../components/MySeparator";
import TransitionComponent from "../components/TransitionComponent";
import { Testimonials } from "../components/testimonials/Testimonials";
import PageStart from "../components/PageStart";
import { getFullSizeImagePath, getPlaceholderImagePath } from "./utils";
import { usePageTitle } from "../hooks/usePageTitle";

const Home = (props) => {
  const styles = {
    media: {
      height: 0,
      paddingTop: "56.25%", // 16:9
    },
    card: {
      position: "relative",
    },
    container: {
      width: "90%",
      backgroundColor: "transparent",
      borderColor: "transparent",
      boxShadow: "none",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignContent: "center",
      zIndex: 1000,
    },
    container1: {
      width: "100%",
      margin: 0,
      zIndex: 1000,
    },
    body1: {
      mt: 0,
      mb: 0,
      width: "90%",
      fontSize: { xs: 12, sm: 13, md: 16, lg: 16, xl: 17 },
      zIndex: 1000,
      position: "relative",
    },
    h1: {
      margin: "auto",
      mt: 0,
      mb: 0,
      fontSize: { xs: 24, sm: 29, md: 36, lg: 45, xl: 54 },
      zIndex: 1000,
    },
    box: {
      width: { xs: 100, sm: 160, md: 200, lg: 250, xl: 300 },
      ml: { xs: 1, sm: 5, md: 8, lg: 10, xl: 12 },
      mr: { xs: 1, sm: 5, md: 6, lg: 10, xl: 12 },
      zIndex: 1000,
    },
  };
  const [imgLoaded] = useState(false);
  const [show, setShow] = useState(false);
  
  usePageTitle("Artistiggo Studio", " | Premium Art for Games");
  
  useEffect(() => {
    const onPageLoad = () => {
      setShow(true);
    };
    // Check if the page has already loaded
    if (document.readyState === "complete") {
      window.setTimeout(() => {
        setShow(true);
      }, 1500);
    } else {
      window.addEventListener("load", onPageLoad);
      // Remove the event listener when component unmounts
      return () => window.removeEventListener("load", onPageLoad);
    }
  }, []);
  const imageName = "home";
  return (
    <>
      <PageStart
        img={getFullSizeImagePath(imageName, props.lessMD)}
        placeholderImg={getPlaceholderImagePath(imageName, props.lessMD)}
        brightness={100}
      />
      {!props.loading ? (
        <Box
          sx={{
            display: !imgLoaded ? "visible" : "collapsed",
            transition: "opacity 1s ease-out 1s",
          }}
        >
          <InfiniteRollingLogos lessMD={props.lessMD} show={show} />

          <Box sx={{ width: "100%", position: "relative" }}>
            <TransitionComponent>
              <MySeparator
                home
                text="End-to-End Visual Production Partner for Industry Leaders"
                pt={{ xs: 4, sm: 6, md: 8, lg: 10, xl: 18 }}
                pb={{ xs: 4, sm: 6, md: 8, lg: 10, xl: 18 }}
              />
            </TransitionComponent>
            <TransitionComponent>
              {props.lessMD ? (
                <Typography
                  variant="body1"
                  paragraph
                  align="center"
                  sx={{
                    ...styles.body1,
                  }}
                >
                  We craft high-impact visuals that make your games
                  unforgettable, immersing players from the first glance to
                  endless play.
                  <br /> <br /> Chosen by industry leaders, Artistiggo Studio is
                  a trusted partner in end-to-end visual production for digital
                  entertainment - delivering high-quality visuals, clear
                  communication, and efficient workflows.
                </Typography>
              ) : (
                <Typography
                  variant="body1"
                  paragraph
                  align="center"
                  sx={{
                    ...styles.body1,
                  }}
                >
                  We craft high-impact visuals that make your games
                  unforgettable,
                  <br /> immersing players from the first glance to endless
                  play.
                  <br /> <br /> Chosen by industry leaders, Artistiggo Studio is
                  a trusted partner in end-to-end <br />
                  visual production for digital entertainment - delivering
                  high-quality visuals, <br /> clear communication, and
                  efficient workflows.
                </Typography>
              )}
            </TransitionComponent>

            <TransitionComponent noSlide>
              <Box
                sx={{
                  mt: "8%",
                  mb: "8%",
                  width: "100%",
                  display: "inline-flex",
                  alignItems: "center",
                  justifyContent: "center",
                  position: "relative",
                }}
              >
                <CountUpLabel
                  num={40}
                  char={"+"}
                  text="TITLES WE'VE WORKED ON"
                  timeout={150}
                />
                <CountUpLabel
                  num={30}
                  char={"+"}
                  text="DEDICATED TEAM MEMBERS"
                  timeout={100}
                />
                <CountUpLabel
                  num={5}
                  text="YEARS ON THE MARKET"
                  timeout={150}
                />
              </Box>
            </TransitionComponent>
          </Box>
          <InfiniteRollingLogos lessMD={props.lessMD} show={show} />
          {props.lessMD ? (
            <>
              <Content2DArtMobile show={show} />
              <InfiniteRollingLogos
                lessMD={props.lessMD}
                mt={{ xs: 3, sm: 5, md: 0, lg: 0, xl: 0 }}
                show={show}
              />
              <Testimonials />
            </>
          ) : (
            <>
              <Content2DArt show={show} />
              <InfiniteRollingLogos lessMD={props.lessMD} show={show} />
              <Testimonials />
            </>
          )}
        </Box>
      ) : (
        <Box sx={{ width: "100%", height: 5000 }}></Box>
      )}
    </>
  );
};

export default Home;
